module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/boletos/boletos.component.html
// module id = ./src/app/modules/dashboard/components/boletos/boletos.component.html
// module chunks = main